import { openbetHttpClient } from "@/api/openbet-http-client";
import type { SazkaDrilldownNodes } from "@/api/interfaces/sazka-drilldown-nodes";
import type { SazkaSearchParams, SazkaSearch } from "@/api/interfaces/sazka-search";
import type { SazkaEventsList, SazkaEventsListParams } from "@/api/interfaces/sazka-events-list";
import type {
    SazkaTrendingEventsList,
    SazkaTrendingEventsListParams,
} from "@/api/interfaces/sazka-trending-events-list";
import type { SazkaSportsParams, SazkaSports } from "@/api/interfaces/sazka-sports";
import { SazkaEventsDetail, SazkaEventsDetailParams } from "@/api/interfaces/sazka-events-detail";
import { CmsContentParams, CmsContentResponse } from "@/api/interfaces/cms-content";
import type { OutrightsParams } from "@/api/interfaces/content-service";
import { appendEnvSuffix } from "@/api/http-client-helpers";

const path = appendEnvSuffix("/content-service");

export async function getSazkaDrilldownNodes() {
    const response = await openbetHttpClient.get<SazkaDrilldownNodes>(`${path}/q/sazka-drilldown-nodes`);
    return response?.data;
}

export async function getSazkaEventsList(params?: SazkaEventsListParams) {
    // Beware: Returns null and throws 'DataFetchingException' if the list is too large eventhough params are optional rather limit it via params.
    const response = await openbetHttpClient.get<SazkaEventsList>(`${path}/q/sazka-events-list`, {
        params,
    });
    return response?.data;
}

export async function getSazkaEventsDetail(params?: SazkaEventsDetailParams) {
    // Beware: Returns null and throws 'DataFetchingException' if the list is too large eventhough params are optional rather limit it via params.
    const response = await openbetHttpClient.get<SazkaEventsDetail>(`${path}/q/sazka-events-detail`, {
        params,
    });
    return response?.data;
}

export async function getSazkaTrendingEventsList(params?: SazkaTrendingEventsListParams) {
    const response = await openbetHttpClient.get<SazkaTrendingEventsList>(`${path}/q/sazka-trending-events-list`, {
        params,
    });
    return response?.data;
}

export async function getSazkaSearch(params: SazkaSearchParams): Promise<SazkaSearch> {
    const response = await openbetHttpClient.get(`${path}/q/sazka-search`, {
        params,
    });
    return response?.data?.data;
}

export async function getSazkaSports(params: SazkaSportsParams): Promise<SazkaSports> {
    const response = await openbetHttpClient.get(`${path}/q/sazka-sports`, {
        params,
    });
    return response?.data;
}

export async function getSazkaLeagues(params?: SazkaSportsParams): Promise<SazkaSports> {
    const response = await openbetHttpClient.get(`${path}/q/sazka-leagues`, {
        params,
    });
    return response?.data;
}

export async function getCmsContent(params: CmsContentParams): Promise<CmsContentResponse> {
    const response = await openbetHttpClient.get(`${path}/q/cms-content`, {
        params,
    });
    return response?.data;
}

export async function getOutrightsList(params: OutrightsParams): Promise<SazkaEventsList> {
    const response = await openbetHttpClient.get(`${path}/q/sazka-outrights-list`, {
        params,
    });
    return response?.data;
}
